<!-- 新批量发布商品 -->
<template>
  <div class='comContent'>
    <!-- <div class="header">
      <div class="title">批量发布商品（待发布商品）</div>
      <div class="headerBox">
        <div class="everyOneBox">
          <span class="number">{{this.numberOne}}</span>
          <span style="padding-left:8px">个商品可一键上架</span>
          <br />
          <div class="secodeBox">
            <span>
              {{matchResult.noNationalCode + matchResult.nationalCodeReject + matchResult.nationalCodeMany + matchResult.reject}}
              <span style="padding-left:8px">个商品通用名称、商品名称、规格、包装单位、批准文号、厂家、产地与标准库ID不一致，发布后将使用标准库信息</span>
            </span><br />
            <span style="display:inline-block; margin-top:5px">
              {{matchResult.noNationalCode + matchResult.nationalCodeReject + matchResult.nationalCodeMany + matchResult.reject}}
              <span style="padding-left:8px">个商品69码与标准库ID不一致</span></span>
          </div>
        </div>
        <div class="everyOneBox">
          <span class="number">
            {{matchResult.success + matchResult.noNationalCode + matchResult.nationalCodeReject + matchResult.nationalCodeMany + matchResult.reject}}
          </span>
          <span style="padding-left:8px">个商品没有商品图片</span>
          <br />
          <div class="secodeBox">
            <span>商品发布后将导致在首页、推荐等重要位置流量受限，立即搜索无图商品，批量上传商品图片</span>
          </div>
        </div>
        <div class="everyOneBox">
          <span class="number">
            {{ matchResult.noNationalCode + matchResult.nationalCodeReject + matchResult.nationalCodeMany + matchResult.reject}}
          </span>
          <span style="padding-left:8px">个商品存在问题</span>
          <br />
          <div class="secodeBox">
            <span>其中包括匹配失败、匹配结果多个、商品信息不全/单位不规范、商品经营范围不在企业经营范围内、暂无销售权限</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="search">
      <div class="">
        <el-input size="small"
                  v-model="chemName"
                  placeholder="商品名称"
                  clearable
                  min-width="50px"></el-input>
      </div>
      <!-- <div class="everyItem">
        <el-input size="small"
                  v-model="input"
                  placeholder="ERP编码"
                  min-width="50px"></el-input>
      </div> -->
      <div class="everyItem">
        <el-input size="small"
                  clearable
                  v-model="factory"
                  placeholder="生产厂家"
                  min-width="50px"></el-input>
      </div>
      <div class="everyItem">
        <el-input size="small"
                  clearable
                  v-model="barCode"
                  placeholder="69码"
                  min-width="50px"></el-input>
      </div>
      <div class="everyItem">
        <el-input size="small"
                  clearable
                  v-model="nationalCode"
                  placeholder="批准文号"
                  min-width="50px"></el-input>
      </div>
      <div class="everyItem">
        <el-select size="small"
                   clearable
                   v-model="syncSourceType"
                   placeholder="导入方式">
          <el-option v-for="item in importOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="everyItem">
        <el-select size="small"
                   clearable
                   v-model="matchResultType"
                   placeholder="匹配结果">
          <el-option v-for="item in resultOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- <div class="everyItem">
        <el-select size="small"
                   v-model="value"
                   placeholder="图片">
          <el-option v-for="item in imgOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div> -->
      <div class="everyItem"
           style="display:flex">
        <el-button size="small"
                   type="primary"
                   @click="query(1)">查询</el-button>
        <el-button size="small"
                   type=""
                   @click="reset">重置</el-button>
      </div>
    </div>
    <div class="buttonClass">
      <div class="buttons">
        <el-button size="small"
                   type="primary"
                   @click="match">执行匹配</el-button>
        <el-button :disabled="activeName != '2'"
                   size="small"
                   type="primary"
                   @click="shelf">一键上架</el-button>
        <el-button size="small"
                   @click="importGoods">批量导入商品</el-button>
        <!-- <el-button size="small"
                   @click="uploadPicture">批量上传商品图片</el-button>
        <el-button size="small"
                   @click="deriveGoods">导出商品</el-button>
        <el-button size="small"
                   @click="importRecord">商品导入记录</el-button> -->
        <el-button size="small"
                   @click="deleteGoods">删除</el-button>
      </div>
      <div class="buttonFont">
        注：该列表内的商品包含“ERP对接抓取的商品” 和 “Excel批量上传的商品”，如您未对接ERP则可点击“批量导入商品”按钮上传商品
      </div>
    </div>
    <div class="bottom">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane :label="`匹配失败（${numberZero}）`"
                     name="0">
          <div class="activeBox"
               v-if="activeName == '0'">
            <MyTable :table-data="tableData"
                     :index="index"
                     :selection="selection"
                     :page="page"
                     :operation="operation"
                     :table-option.sync="tableOption"
                     @page-change="getList"
                     @handleSelectionChange="handleSelectionChange">
              <!-- <template slot="image"
                        slot-scope="scope">
                <span style="display:block;width:100px;height:100px">
                  <ImgUpload v-model="scope.row.image"
                             @onSuccessUpload="onSuccessUpload(scope.row)"
                             :limit="1"
                             style="position:relative;top:-8px">
                  </ImgUpload>
                </span>
              </template> -->
              <template slot="packUnit"
                        slot-scope="scope">
                <span>
                  {{scope.row.packUnit}}
                </span>
                <i class="el-icon-edit-outline"
                   style="color:#F5222D;
                   cursor:pointer"
                   @click="unitDetail(scope.row,scope.$index)"></i>
              </template>
              <template slot="id"
                        slot-scope="scope">
                <span>
                  {{scope.row.id}}
                </span>
                <i class="el-icon-edit-outline"
                   style="color:#F5222D;
                   cursor:pointer"
                   @click="matchId(scope.row)"></i>
              </template>
              <!-- <template slot="caozuo"
                        slot-scope="scope">
                <el-link type="primary"
                         @click="supplementary(scope.row,false)"
                         :underline="false">补充商品信息</el-link>
              </template> -->
            </MyTable>
          </div>

        </el-tab-pane>
        <el-tab-pane :label="`匹配成功待上架（${numberOne}）`"
                     name="2">
          <div class="activeBox"
               v-if="activeName == '2'">
            <MyTable :table-data="tableData"
                     :index="index"
                     :selection="selection"
                     :page="page"
                     :operation="operation"
                     :table-option.sync="tableOption"
                     @page-change="getList"
                     @handleSelectionChange="handleSelectionChange">
              <template slot="image"
                        slot-scope="scope">
                <span style="display:block;width:100px;height:100px">
                  <ImgUpload v-model="scope.row.goodsBaseDTO.image"
                             @onRemoveHandler="onRemoveHandler(scope.row)"
                             @onSuccessUpload="onSuccessUpload(scope.row)"
                             :limit="1"
                             style="position:relative;top:-8px">
                  </ImgUpload>
                </span>
              </template>
              <template slot="chemName"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.chemName != scope.row.goodsBaseDTO.name">
                    平台名称：
                  </span>
                  {{scope.row.goodsBaseDTO.name}}
                </p>
                <p v-if="scope.row.chemName != scope.row.goodsBaseDTO.name"
                   style="color:red">
                  供应商名称：{{scope.row.chemName}}
                </p>
              </template>
              <template slot="factory"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.factory != scope.row.goodsBaseDTO.factory">
                    平台厂家：
                  </span>
                  {{scope.row.goodsBaseDTO.factory}}
                </p>
                <p v-if="scope.row.factory != scope.row.goodsBaseDTO.factory"
                   style="color:red">
                  供应商厂家：{{scope.row.factory}}
                </p>
              </template>
              <template slot="specification"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.specification != scope.row.goodsBaseDTO.specification">
                    平台规格：
                  </span>

                  {{scope.row.goodsBaseDTO.specification}}
                </p>
                <p v-if="scope.row.specification != scope.row.goodsBaseDTO.specification"
                   style="color:red">
                  供应商规格：{{scope.row.specification}}

                </p>
              </template>
              <template slot="packUnit"
                        slot-scope="scope">
                <span>
                  {{scope.row.packUnit}}
                </span>
                <i class="el-icon-edit-outline"
                   style="color:#F5222D;
                   cursor:pointer"
                   @click="unitDetail(scope.row,scope.$index)"></i>
              </template>
              <template slot="id"
                        slot-scope="scope">
                <span>
                  {{scope.row.id}}
                </span>
                <i class="el-icon-edit-outline"
                   v-if="scope.row.matchResultType == '4'"
                   style="color:#F5222D;
                   cursor:pointer"
                   @click="matchId(scope.row)"></i>
              </template>
              <!-- <template slot="caozuo"
                        slot-scope="scope">
                <el-link type="primary"
                         @click="supplementary(scope.row,true)"
                         :underline="false">补充商品信息</el-link>
              </template> -->
            </MyTable>
          </div>

        </el-tab-pane>
        <el-tab-pane :label="`已上架（${numberTwo}）`"
                     name="3">
          <div class="activeBox"
               v-if="activeName == '3'">
            <MyTable :table-data="tableData"
                     :isLoading="isLoading"
                     :index="index"
                     :selection="selection"
                     :page="page"
                     :operation="operation"
                     :table-option.sync="tableOption"
                     @page-change="getList"
                     @handleSelectionChange="handleSelectionChange">
              <template slot="image"
                        slot-scope="scope">
                <span style="display:block;width:100px;height:100px">
                  <ImgUpload v-model="scope.row.goodsBaseDTO.image"
                             @onRemoveHandler="onRemoveHandler(scope.row)"
                             @onSuccessUpload="onSuccessUpload(scope.row)"
                             :limit="1"
                             style="position:relative;top:-8px">
                  </ImgUpload>
                </span>
              </template>
              <template slot="chemName"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.chemName != scope.row.goodsBaseDTO.name">
                    平台名称：
                  </span>
                  {{scope.row.goodsBaseDTO.name}}
                </p>
                <p v-if="scope.row.chemName != scope.row.goodsBaseDTO.name"
                   style="color:red">
                  供应商名称：{{scope.row.chemName}}
                </p>
              </template>
              <template slot="factory"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.factory != scope.row.goodsBaseDTO.factory">
                    平台厂家：
                  </span>
                  {{scope.row.goodsBaseDTO.factory}}
                </p>
                <p v-if="scope.row.factory != scope.row.goodsBaseDTO.factory"
                   style="color:red">
                  供应商厂家：{{scope.row.factory}}
                </p>
              </template>
              <template slot="specification"
                        slot-scope="scope">
                <p>
                  <span v-if="scope.row.specification != scope.row.goodsBaseDTO.specification">
                    平台规格：
                  </span>

                  {{scope.row.goodsBaseDTO.specification}}
                </p>
                <p v-if="scope.row.specification != scope.row.goodsBaseDTO.specification"
                   style="color:red">
                  供应商规格：{{scope.row.specification}}

                </p>
              </template>
              <template slot="packUnit"
                        slot-scope="scope">
                <span>
                  {{scope.row.packUnit}}
                </span>
                <i class="el-icon-edit-outline"
                   style="color:#F5222D;cursor:pointer"
                   @click="unitDetail(scope.row,scope.$index)"></i>
              </template>
              <!-- <template slot="price"
                        slot-scope="scope">
                <p>
                  零售价：{{scope.row.retailPrice}}
                </p>
                <p>
                  批发价：{{scope.row.tradePrice}}
                </p>
              </template> -->
              <template slot="id"
                        slot-scope="scope">
                <span>
                  {{scope.row.id}}
                </span>
                <i class="el-icon-edit-outline"
                   v-if="scope.row.matchResultType == '4'"
                   style="color:#F5222D;
                   cursor:pointer"
                   @click="matchId(scope.row)"></i>
              </template>
              <template slot="caozuo"
                        slot-scope="scope">
                <el-link type="primary"
                         :underline="false"
                         @click="supplementary(scope.row,true)">补充商品信息</el-link>
              </template>
            </MyTable>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 初次进来的弹窗 -->
    <!-- <el-dialog title="商品匹配结果不一致提醒"
               :visible.sync="resultdialogVisible"
               width="30%">
      <span>您有
        {{matchResult.noNationalCode + matchResult.nationalCodeReject + matchResult.nationalCodeMany + matchResult.reject}}
        个商品通用名称、商品名称、规格、包装单位、批准文号、厂家、产地与匹配的标配不一致，发布后将使用标配信息，请检查无误后再发布或重新创建商品</span>
      <p>提示：请认证检查列表上的标红信息，否则将导致客户收到的货物与平台展示的商品信息不符，引起客诉！</p>
    </el-dialog> -->
    <!-- 选择单位的弹窗 -->
    <UnitDialog :unit-list="unitList"
                :dialog-visible="dialogVisible"
                @submitCheck="submitCheck" />
    <!-- 批量导入 -->
    <el-dialog title="批量导入"
               :visible.sync="importVisible"
               width="30%">
      <div>
        <div class="box">
          <p>1: 先下载导入模板，按格式填写数据</p>
          <p style="color:orange">（注：Excel 中黄色为必填字段，其他为非必填字段，请按示例格式规范填写）</p>
          <el-button size="small"
                     icon="el-icon-bottom"
                     type="primary"
                     @click="fileTemplate">下载模板</el-button>
        </div>
        <div class="box">
          <p>2: 选择保存的Excel文件，点击导入即可完成批量导入</p>
          <p style="color:orange">（注：仅限 xlsx 格式）</p>
          <el-upload class="upload-demo"
                     accept=".xlsx"
                     :show-file-list="false"
                     :action="action"
                     :on-success="success"
                     multiple
                     :headers="headers">
            <el-button size="small"
                       icon="el-icon-top"
                       type="primary">表格导入</el-button>
          </el-upload>
        </div>
      </div>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="dialogVisible = false">取 消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- 匹配商品 -->
    <el-dialog title="选择商品"
               :visible.sync="goodsVisible"
               width="880px">
      <p>商品名称：{{params.chemName}}，规格：{{params.specification}}，生产厂家：{{params.factory}}</p>
      <p>以下列表中，请选择商品信息一致的商品（规格数字一样的描述不一样的，可视为一致），如果无匹配的商品，请从新增上架途径单独上架。</p>
      <div style="display:flex; height: 500px;overflow: auto;">
        <GoodsCard :params="params"
                   :goodsData="goodsData"
                   :activeIndex.sync="activeIndex"
                   @choiceItem="choiceItem" />
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="goodsVisible = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import ImgUpload from '@/components/imgUpload'
import GoodsCard from "./goodsCard"
import { getToken } from "@/utils/auth";
import { getmatchTask, matchDataPage, unMatchDataPage, goodsSkuMatchTasks, fileExport, productDataImport, fileTemplate, targetDataPage, MatchDataConfirm, getList, goodsSkuSyncCaches, goodsBases, associations, goodsSkuSyncCachesPackUnit, quantity, deleteRecords, goodsSkuSyncCacheStatistics, goodsSkuSyncCachesPublish, goodsSkuSyncCacheStatisticsStates } from '@/api/release'
import { addImages } from '@/api/commodityreference'
import { getunitList } from '@/api/productManage/auditProduct'
import UnitDialog from '@/components/unitDialog'
import MyTable from '@/components/myTable'
export default {

  components: { MyTable, UnitDialog, GoodsCard, ImgUpload },
  data () {
    return {
      params: {}, // 当前行数据
      selections: [], // 选中的列表数据
      numberZero: 0,
      numberOne: 0,
      numberTwo: 0,
      waiBuId: '', // 外面的id
      choiceGoods: '', // 选中的商品
      activeIndex: 0, // 商品选中索引
      goodsVisible: false, // 匹配商品
      goodsData: [
      ],
      importVisible: false,
      action: process.env.VUE_APP_BASE_API + '/drug/goods/goodsSkuImportRecords/file', // 批量导入地址
      resultdialogVisible: false,
      dialogVisible: false, // 单位
      tableIndex: 0,
      unitList: [],
      isLoading: false,
      operation: false, // table组件中的操作按钮
      selection: true, // 表格是否支持选择
      index: false, // 表格中的序号
      tableData: [ // 表格数据
      ],
      tableOption: [ // table中的columns
        // { label: '编号', prop: 'goodsId' },
        { label: '匹配状态', prop: 'matchResultTypeStr' }, // 这里表示自定义列
        { label: '商品来源', prop: 'syncSourceTypeStr' },
        // { label: '商品图片', prop: 'image', slot: true, width: '120' },
        { label: '供应商商品编码', prop: 'shopGoodsCode' },
        { label: '平台商品ID', prop: 'goodsId', width: '120' },
        { label: '商品名称', prop: 'chemName', width: '200' },
        { label: '生产厂家', prop: 'factory', minWidth: '200' },
        // { label: '产地', prop: 'factory' },
        { label: '规格', prop: 'specification', minWidth: '200' },
        { label: '条码', prop: 'barCode' },
        { label: '批准文号', prop: 'nationalCode', minWidth: '200' },
        { label: '最小包装单位', prop: 'packUnit', slot: true },
        // { label: '价格', prop: 'price', slot: true },
        { label: '库存', prop: 'qty' },
        { label: '匹配ID', prop: 'id', slot: true },
        // { label: '是否有图', prop: 'status' },
        // { label: '操作', prop: 'caozuo', slot: true, minWidth: '100' },
      ],
      page: { // 表格中的page
        total: 10,
        current: 1,
        size: 10
      },
      activeName: '0', // tab
      // 导入列表
      importOptions: [
        {
          value: '0',
          label: 'EXCEL导入'
        }, {
          value: '1',
          label: 'ERP对接'
        }
      ],
      // 匹配结果列表
      resultOptions: [
        {
          label: '待匹配',
          value: '0'
        },
        {
          label: '匹配成功',
          value: '1'
        }, {
          label: '国药准字缺失',
          value: '2'
        },
        {
          label: '未匹配到国药准字',
          value: '3'
        },
        {
          label: '匹配到国药准字',
          value: '4'
        },
        {
          label: '匹配失败',
          value: '100'
        }
      ],
      // 有无图片列表
      imgOptions: [
        {
          label: '有图',
          value: '1'
        },
        {
          label: '无图',
          value: '2'
        }
      ],
      chemName: '',
      barCode: '',
      factory: '',
      nationalCode: '',
      syncSourceType: '',
      matchResultType: '',
      matchResult: {
        success: 0,
        noNationalCode: 0,
        nationalCodeReject: 0,
        nationalCodeMany: 0,
        reject: 0,
      }
    };
  },
  computed: {
    headers: function () {
      return {
        Authorization: 'Bearer ' + getToken(),
      }
    },
  },
  watch: {
    activeName (val) {
      if (val == '0') {
        this.tableOption = [ // table中的columns
          // { label: '编号', prop: 'goodsId' },
          { label: '匹配状态', prop: 'matchResultTypeStr' }, // 这里表示自定义列
          { label: '商品来源', prop: 'syncSourceTypeStr' },
          // { label: '商品图片', prop: 'image', slot: true, width: '120' },
          { label: '供应商商品编码', prop: 'shopGoodsCode' },
          { label: '平台商品ID', prop: 'goodsId', width: '120' },
          { label: '商品名称', prop: 'chemName', width: '200' },
          { label: '生产厂家', prop: 'factory', minWidth: '200' },
          // { label: '产地', prop: 'factory' },
          { label: '规格', prop: 'specification', minWidth: '200' },
          { label: '条码', prop: 'barCode' },
          { label: '批准文号', prop: 'nationalCode', minWidth: '200' },
          { label: '最小包装单位', prop: 'packUnit', slot: true },
          // { label: '价格', prop: 'price', slot: true },
          { label: '库存', prop: 'qty' },
          { label: '匹配ID', prop: 'id', slot: true },
          // { label: '是否有图', prop: 'status' },
          // { label: '操作', prop: 'caozuo', slot: true, minWidth: '100' },
        ]
      } else {
        this.tableOption = [ // table中的columns
          // { label: '编号', prop: 'goodsId' },
          { label: '匹配状态', prop: 'matchResultTypeStr' }, // 这里表示自定义列
          { label: '商品来源', prop: 'syncSourceTypeStr' },
          { label: '商品图片', prop: 'image', slot: true, width: '120' },
          { label: '供应商商品编码', prop: 'shopGoodsCode' },
          { label: '平台商品ID', prop: 'goodsId', width: '120' },
          // { label: 'ERP编码', prop: 'barCode' },
          { label: '商品名称', prop: 'chemName', width: '200', slot: true },
          { label: '生产厂家', prop: 'factory', minWidth: '200', slot: true },
          // { label: '产地', prop: 'factory' },
          { label: '规格', prop: 'specification', slot: true, minWidth: '200' },
          { label: '条码', prop: 'barCode' },
          { label: '批准文号', prop: 'nationalCode', minWidth: '200' },
          { label: '最小包装单位', prop: 'packUnit', slot: true },
          // { label: '价格', prop: 'price', slot: true },
          { label: '库存', prop: 'qty' },
          { label: '匹配ID', prop: 'id', slot: true },
          // { label: '是否有图', prop: 'status' },
          // { label: '操作', prop: 'caozuo', slot: true, minWidth: '100' },
        ]
      }
    }
  },
  methods: {
    // 上传成功
    onSuccessUpload (row) {
      this.params = row
      this.$nextTick(() => {
        this.concatImage()
      })
    },
    onRemoveHandler (row) {
      this.params = row
      // const params = {
      //   goodsId: this.params.goodsId,
      //   image: ''
      // }
      // addImages(params).then((res) => {
      //   if (res.code == 0) {
      //     this.$message.success('删除成功')
      //   }
      // })
    },
    // 关联商品和图片
    concatImage () {
      const params = {
        goodsId: this.params.goodsId,
        image: this.params.goodsBaseDTO.image[0]
      }
      addImages(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('上传成功')
        }
      })
    },
    // 选中商品
    choiceItem (item) {
      this.choiceGoods = item
    },
    // 选择商品 提交
    submit () {
      this.activeIndex = 0
      this.goodsVisible = false
      let params = {
        goodsId: this.choiceGoods.id,
      }
      associations(this.waiBuId, params).then(res => {
        this.$message.success('操作成功')
        this.goodsSkuSyncCacheStatisticsStates()
        this.query(1)
        this.goodsSkuSyncCacheStatistics()
      })
    },
    // 匹配ID
    matchId (row) {
      this.goodsVisible = true
      this.waiBuId = row.id
      this.params = row
      let params = {
        size: 100,
        current: 1,
        approvalNumber: row.nationalCode,
        skuCacheSpecification: row.specification
      }
      goodsBases(params).then(res => {
        this.goodsData = res
        if (this.goodsData.length > 0) {
          this.choiceGoods = this.goodsData[0]
        }
      })
    },
    // 下载模板
    fileTemplate () {
      fileTemplate().then(res => {
        window.location.href = res
      })
    },
    // 上传成功
    success (res) {
      if (res.code === 1) {
        this.$message.error(res.msg)
      } else {
        this.$message.success('上传成功')
        this.importVisible = false
        this.goodsSkuSyncCacheStatisticsStates()
        // this.getunitList()
        this.query(1)
        this.goodsSkuSyncCacheStatistics()
        // this.getmatchTask(this.clickId)
      }
    },
    // 获取单位字典
    getunitList () {
      getunitList().then(res => {
        if (res.code == 0) {
          this.unitList = res.data || []
          // this.tableData[0].packUnit = this.unitList.length > 0 ? this.unitList[0] : ''
        }
      })
    },
    // 选择单位
    unitDetail (row, index) {
      this.waiBuId = row.id
      this.tableIndex = index
      this.dialogVisible = true
    },
    // 确认选中的单位
    submitCheck (item) {
      this.tableData[this.tableIndex].packUnit = item
      let params = {
        packUnit: item
      }
      goodsSkuSyncCachesPackUnit(this.waiBuId, params).then(res => {
        this.$message.success('修改成功')
        this.query()
      })
    },
    // 获取page
    getList () {

      this.query()
    },
    // 选中
    handleSelectionChange (val) {
      this.selections = val
    },
    // 查询
    query (current) {
      if (this.current) {
        this.page.current = current
      }
      let params = {
        chemName: this.chemName ? this.chemName : null,
        barCode: this.barCode ? this.barCode : null,
        factory: this.factory ? this.factory : null,
        nationalCode: this.nationalCode ? this.nationalCode : null,
        syncSourceType: this.syncSourceType ? this.syncSourceType : null,
        matchResultType: this.matchResultType ? this.matchResultType : null,
        status: 0,
        state: this.activeName,
        size: this.page.size,
        current: this.page.current
      }
      goodsSkuSyncCaches(params).then(res => {
        this.tableData = res
        if (this.tableData.length > 0) {
          this.tableData.forEach(item => {
            if (item.goodsBaseDTO) {
              if (item.goodsBaseDTO.image) {
                item.goodsBaseDTO.image = item.goodsBaseDTO.image.split(',')
              } else {
                this.$set(item.goodsBaseDTO, 'image', [])
              }
            } else {
              this.$set(item, 'goodsBaseDTO', {})
              this.$set(item.goodsBaseDTO, 'image', [])
              console.log(item.goodsBaseDTO)
            }
          })
        }
      })
      quantity(params).then(res => {
        this.page.total = Number(res)
      })
    },
    // 查询头部数据
    goodsSkuSyncCacheStatistics () {
      goodsSkuSyncCacheStatistics().then(res => {
        if (res.length > 0) {
          res.forEach(item => {
            switch (item.matchResultType) {
              case 1:
                this.matchResult.success = item.quantity;
                break;
              case 2:
                this.matchResult.noNationalCode = item.quantity;
                break;
              case 3:
                this.matchResult.nationalCodeReject = item.quantity;
                break;
              case 4:
                this.matchResult.nationalCodeMany = item.quantity;
                break;
              case 100:
                this.matchResult.reject = item.quantity;
                break;

            }
          })
          this.resultdialogVisible = true
        }

      })
    },
    // 重置
    reset () {
      this.chemName = '',
        this.barCode = '',
        this.factory = '',
        this.nationalCode = '',
        this.syncSourceType = '',
        this.matchResultType = '',
        this.page.current = 1
    },
    // 一键上架
    shelf () {
      if (this.selections.length > 0) {
        let params = {
          cacheIdSet: []
        }
        this.selections.forEach(item => {
          params.cacheIdSet.push(item.id)
        }
        )
        goodsSkuSyncCachesPublish(params).then(res => {
          this.$message.success('上架成功')
          this.query(1)
          this.goodsSkuSyncCacheStatisticsStates()
          this.goodsSkuSyncCacheStatistics()
          // this.goodsSkuSyncCacheStatistics()
        })
      } else {
        this.$message.warning('请先选择数据')
      }
    },
    // 重新匹配
    match () {
      goodsSkuMatchTasks({}).then(res => {
        this.$message.success('匹配完成')
        this.query(1)
        this.goodsSkuSyncCacheStatistics()
        this.goodsSkuSyncCacheStatisticsStates()
      })
    },
    // 批量导入商品
    importGoods () {
      this.importVisible = true
    },
    // 批量上传商品图片
    uploadPicture () {

    },

    // 导出商品
    deriveGoods () {

    },
    // 商品导入记录
    importRecord () {

    },
    // 删除
    deleteGoods () {
      if (this.selections.length > 0) {
        let params = {
          cacheIdSet: []
        }
        this.selections.forEach(item => {
          params.cacheIdSet.push(item.id)
        }
        )
        deleteRecords(params).then(res => {
          this.$message.success('删除成功')
          this.query(1)
          this.goodsSkuSyncCacheStatistics()
          this.goodsSkuSyncCacheStatisticsStates()
        })
      } else {
        this.$message.warning('请先选择数据')
      }

    },
    // tab切换
    handleClick () {
      this.tableData = []
      this.query(1)
    },
    // 补充商品信息
    supplementary (row, editType) {
      this.$router.push({ path: '/productManage/release-releaseDetail', query: row })
    },
    // 查询未发布已发布数据
    goodsSkuSyncCacheStatisticsStates () {
      let params = {
        shopId: 0
      }
      goodsSkuSyncCacheStatisticsStates(params).then(res => {
        if (res.length > 0) {
          this.numberOne = 0
          this.numberTwo = 0
          this.numberZero = 0
          res.forEach(item => {
            if (item.state == 2) {
              this.numberOne = item.quantity
            } else if (item.state == 3) {
              this.numberTwo = item.quantity
            } else if (item.state == 0) {
              this.numberZero = item.quantity
            }
          })
        }
      })
    }
  },
  created () {
    this.goodsSkuSyncCacheStatisticsStates()
    this.getunitList()
    this.query()
    this.goodsSkuSyncCacheStatistics()
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
}
</script>
<style lang='scss' scoped>
.comContent {
  .header {
    .title {
      height: 56px;
      line-height: 56px;
      font-size: 16px;
      font-weight: 700;
      color: #262626;
    }
    .headerBox {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .everyOneBox {
        width: 49.5%;
        padding: 15px;
        font-size: 14px;
        color: #595959;
        border: 1px solid #f5f5f5;
        border-radius: 4px;
        .number {
          font-size: 16px;
          color: #262626;
        }
        .secodeBox {
          width: 100%;
          margin-top: 15px;
        }
      }
    }
  }
  .search {
    display: flex;
    padding: 24px 0;
    .everyItem {
      margin-left: 8px;
    }
  }
  .buttonClass {
    .buttons {
      display: flex;
    }
    .buttonFont {
      padding-top: 15px;
      font-size: 14px;
      color: #595959;
    }
  }
  .bottom {
    margin-top: 16px;
    // height: calc(100% - 320px);
    ::v-deep .el-tabs {
      height: 100%;
      .el-tabs__header {
        border-bottom: 1px solid #f5f5f5;
      }
      .el-tabs__content {
        height: calc(100% - 56px);
        .el-tab-pane {
          height: calc(100% - 45px);
          .activeBox {
            height: 100%;
          }
        }
      }
    }
  }
  ::v-deep .zt__table {
    .el-table {
      .el-table__body-wrapper {
        height: calc(100% - 65px);
      }
    }
  }
}
</style>